import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

export default function FreeAnswerRepeatButton({ disabled, onRepeat, showPointer }) {
  return (
    <div className="freeAnswer__repeatBtn">
      <AmiraIconButton
        type={ICON_BUTTON_TYPES.REPEAT_AUDIO}
        secondary
        onClick={() => !disabled && onRepeat && onRepeat()}
        disabled={disabled}
        pointerPosition="bottom"
        showPointer={showPointer}
      />
    </div>
  );
}
